/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError } from 'axios';
import Core from '../core';

async function getAllClaimTypes(companyId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/claim/types?company_id=${companyId}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllEmployeeClaims(empId: number, companyId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getPendingClaims?emp_id=${empId}&company_id=${companyId}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function applyClaim(payload: any) {
  const api = Core.getInstance().apiforImageUp();
  const data = await api.post(`/v1/claim/create`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllClaimHistory(empId: number, companyId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getClaimHistory?emp_id=${empId}&company_id=${companyId}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllClaimHistoryWithYear(
  empId: number,
  companyId: number,
  year: number,
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getClaimHistory?emp_id=${empId}&company_id=${companyId}&year=${year}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getTripTypes(empId: number, companyId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/trip/types?emp_id=${empId}&company_id=${companyId}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllAirTickets(empId: number, companyId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getPendingAirTickets?emp_id=${empId}&company_id=${companyId}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function applyAirticket(payload: any) {
  const api = Core.getInstance().apiforImageUp();

  return new Promise((resolve, reject) => {
    api
      .post(`/v1/airTicket/create`, payload)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        return reject(error);
      });
  });
}

async function getEmployeeBenefitStatus(empId: any) {
  const api = Core.getInstance().apiforImageUp();

  return new Promise((resolve, reject) => {
    api
      .get(`/v1/employee/getEmployeeBenefitStatus?empId=${empId}`)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        return reject(error);
      });
  });
}

export const claimService = {
  getAllClaimTypes,
  getAllEmployeeClaims,
  applyClaim,
  getAllClaimHistory,
  getAllClaimHistoryWithYear,
  getAllAirTickets,
  getTripTypes,
  applyAirticket,
  getEmployeeBenefitStatus,
};
